module.exports = __webpack_public_path__ + "static/lss-785631c92787ad4bb1a367c1b30bbe11.png";